import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEraser } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'flowbite';


const optionsTooltip = {
  placement: 'bottom',
  triggerType: 'click',
  onHide: () => {
      console.log('tooltip is shown');
  },
  onShow: () => {
      console.log('tooltip is hidden');
  },
  onToggle: () => {
      console.log('tooltip is toggled');
  },
};

// instance options with default values
const instanceOptions = {
  id: 'tooltipContent',
  override: true
};

const stopWords = ['a', 'an', 'and', 'the', 'is', 'in', 'of', 'to', 'it', 'that'];

const SlugUrlGenerator = () => {
  const [title, setTitle] = useState('');
  const [slug, setSlug] = useState('');
  const [options, setOptions] = useState({
    separator: '-', // '-' or '_'
    lowercase: true, // true or false
    removeSpecialChars: true, // true or false
    removeStopWords: true, // true or false
    removeNumbers: false, // true or false
  });

  const generateSlug = (input) => {
    let slug = input;

    // Remove stop words if option is enabled
    if (options.removeStopWords) {
      slug = slug
        .split(' ')
        .filter(word => !stopWords.includes(word.toLowerCase()))
        .join(' ');
    }

    // Remove numbers if option is enabled
    if (options.removeNumbers) {
      slug = slug.replace(/\d+/g, '');
    }

    // Replace spaces with the chosen separator
    slug = slug.replace(/\s+/g, options.separator);

    // Remove special characters if option is enabled
    if (options.removeSpecialChars) {
      slug = slug.replace(/[^\w\-]+/g, '');
    }

    // Convert to lowercase if option is enabled
    if (options.lowercase) {
      slug = slug.toLowerCase();
    }

    // Replace multiple separators with a single one
    slug = slug.replace(new RegExp(`${options.separator}{2,}`, 'g'), options.separator);

    // Trim separators from the start and end
    slug = slug.replace(new RegExp(`^${options.separator}+|${options.separator}+$`, 'g'), '');

    return slug;
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setTitle(value);
    // setSlug(generateSlug(value));
  };

  const handleOptionChange = (option) => (e) => {
    setOptions({ ...options, [option]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
    // setSlug(generateSlug(title));
  };

  const handleCopy = () => {
    const $targetEl = document.getElementById('tooltipContent');
    const $triggerEl = document.getElementById('tooltipButton');
    const tooltip = new Tooltip($targetEl, $triggerEl, optionsTooltip, instanceOptions);
    navigator.clipboard.writeText(slug)
      .then(() => tooltip.show())
      // .catch(() => alert('Failed to copy!'));
  };

  useEffect(() => {
    if (title || options) {
      setSlug(generateSlug(title));
    }
  }, [title, options])

  return (
    <div className="grid grid-cols-1 xl:grid-cols-1 xl:gap-4">
      <div className="col-span-full xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          {/* <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>INPUT STRING: (Article title, tutorial title or any web page title)</h3>
          </div> */}
          <div className="px-4 py-2 text-gray-400  rounded dark:border-gray-600">
            {/* <input
              type="text"
              id="default-input"
              value={title}
              onChange={handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-2/4 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"/> */}
            <div className="relative w-2/4">
              <input
                type="text"
                value={title}
                onChange={handleChange}
                className="bg-gray-50 border w-full border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required={true}
                placeholder='INPUT STRING: Article title, tutorial title or any web page title'
              />
              <button
                type="button"
                disabled={!title}
                onClick={() => setTitle('')}
                className="absolute top-0 end-0 px-4 p-2.5 h-full text-sm font-medium text-white bg-gray-500 rounded-e-lg border border-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800"
              >
                <FontAwesomeIcon icon={faEraser}/>
              </button>
            </div>
            <label for="countries" className="block mt-4 mb-2 text-sm font-medium text-gray-900 dark:text-white">Separator</label>
            <select value={options.separator} onChange={handleOptionChange('separator')} className="bg-gray-50 w-2/12 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option value="-">Dash (-)</option>
              <option value="_">Underscore (_)</option>
            </select>
            <div className="flex items-center mt-4">
              <input
                checked={options.lowercase}
                onChange={handleOptionChange('lowercase')}
                id="checked-checkbox" type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
              <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Lowercase</label>
            </div>
            <div className="flex items-center mt-4">
              <input
                checked={options.removeSpecialChars}
                onChange={handleOptionChange('removeSpecialChars')}
                id="checked-checkbox-2" type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
              <label for="checked-checkbox-2" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remove Special Characters</label>
            </div>
            <div className="flex items-center mt-4">
              <input
                checked={options.removeStopWords}
                onChange={handleOptionChange('removeStopWords')}
                id="checked-checkbox-3" type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
              <label for="checked-checkbox-3" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remove Stop Words (English Only)</label>
            </div>
            <div className="flex items-center mt-4">
              <input
                checked={options.removeNumbers}
                onChange={handleOptionChange('removeNumbers')}
                id="checked-checkbox-4" type="checkbox"
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
              <label for="checked-checkbox-4" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Remove Numbers</label>
            </div>
          </div>
          {/* <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>OUTPUT: (Clean URL slug)</h3>
          </div> */}
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <div className="relative w-2/4">
              <input
                type="text"
                value={slug}
                className="block p-4 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-lg rounded-s-gray-100 rounded-s-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                placeholder="Slug will be shown here automatically..."
                required=""
              />
              <button
                type="button"
                onClick={handleCopy}
                id='tooltipButton'
                disabled={!slug}
                className="absolute top-0 end-0 px-4 p-2.5 h-full text-sm font-medium text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                <FontAwesomeIcon icon={faCopy}/>
              </button>
              <div id="tooltipContent" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                Coppied
                <div class="tooltip-arrow" data-popper-arrow></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SlugUrlGenerator;
